import {HttpVerbo, xfetch} from "../util";
import {Usuario} from '../tipos/usuario';
import {Demanda} from "../tipos/demanda";

export default class DemandaServico {

  static buscarDodsAsplan(usuario: Usuario) {
    return xfetch('/demanda/usuario/'+usuario.id, {}, HttpVerbo.GET)
  }

  static baixarDods(listaDods: Demanda[]) {
    const ids = listaDods.map(d => d.id);
    xfetch('/demanda/exportar', {'ids': ids}, HttpVerbo.POST)
      .then( res => res.blob() )
      .then( blob => {
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = "exportar_dod.xls";
        a.click();
      });
  }

  static buscarDemanda(id: number) {
    return xfetch(`/demanda/${id}`, {}, HttpVerbo.GET)
      .then(res => res.json())
  }
}